import store from "@/store";

export const allSupportLangs = [
    {
        lang: "en",
        i18nKey: "zhiji.common.english"
    },
    {
        lang: "ja",
        i18nKey: "zhiji.common.ja"
    },
    {
        lang: "ko",
        i18nKey: "zhiji.common.ko"
    },
    {
        lang: "ar",
        i18nKey: "zhiji.common.ar"
    },
    {
        lang: "ru",
        i18nKey: "zhiji.common.ru"
    },
    {
        lang: "id",
        i18nKey: "zhiji.common.id"
    },
    {
        lang: "tr",
        i18nKey: "zhiji.common.tr"
    },
    {
        lang: "de",
        i18nKey: "zhiji.common.de"
    },
    {
        lang: "fr",
        i18nKey: "zhiji.common.fr"
    },
    {
        lang: "zh",
        i18nKey: "zhiji.common.zh"
    },
    {
        lang: "zh-HK",
        i18nKey: "zhiji.common.zhHK"
    },
    {
        lang: "zh-TW",
        i18nKey: "zhiji.common.zhTW"
    },
    {
        lang: "pt",
        i18nKey: "zhiji.common.pt"
    },
    {
        lang: "th",
        i18nKey: "zhiji.common.th"
    },
    {
        lang: "es",
        i18nKey: "zhiji.common.caES"
    },
    {
        lang: "vi",
        i18nKey: "zhiji.common.vi"
    },
    {
        lang: "ms",
        i18nKey: "zhiji.common.ms"
    },
    {
        lang: "un",
        i18nKey: "zhiji.common.un"
    }
];

export function businessLangs() {
    const businessSetting = store.state.auth.businessSetting || {};
    const businessLangs = businessSetting.languages || [];
    return allSupportLangs.slice().filter(lang => ~businessLangs.indexOf(lang.lang));
}
